// Public instructions only. Never interpolate project context, images or credentials.
export const SETUP_PROMPT = "I want to use deepface.dev for facial verification in this project. Follow the instructions at https://deepface.dev/skill.md";
const encodedPrompt = encodeURIComponent(SETUP_PROMPT);
export const SETUP_LINKS = [
  { name: "Codex", id: "codex", icon: "codex", href: `codex://new?prompt=${encodedPrompt}`, title: "Open in Codex" },
  { name: "Claude Code", id: "claude", icon: "claude-color", href: `https://claude.ai/code/new?q=${encodedPrompt}`, title: "Open in Claude Code" },
  { name: "Cursor", id: "cursor", icon: "cursor", href: `https://cursor.com/link/prompt?text=${encodedPrompt}`, title: "Open in Cursor" },
] as const;
export const COPY_PROVIDERS = [
  { name: "Antigravity", id: "antigravity", icon: "antigravity-color" },
  { name: "GitHub Copilot", id: "copilot", icon: "githubcopilot" },
  { name: "Devin Desktop", id: "devin", icon: "devin-color" },
] as const;
